module.exports = "/assets/data/185110d8df12da4ef9673f81878c7f0d-L36.data.json";